'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowLeft } from '@redteclab/icons'

import { Button } from 'base-ui'

import { cmsStoryblokSlugToPublicUrl } from '../../cmsStoryblokSlugToPublicUrl'
import { useStoryblokStory } from '../../context/StoryblokStoryContext'

/**
 * Cut last segment after slash (`/`) to get one level up path.
 *
 * @example
 * category/sub-category -> category
 * example/path/end-slug -> example/path
 */
const getParentPath = (path: string): string => {
  const lastSlashIndex = path.lastIndexOf('/')

  if (lastSlashIndex === -1) {
    return path
  }

  return path.slice(0, lastSlashIndex)
}

export const StoryblokAdvicePageBackLink: FC = () => {
  const { story } = useStoryblokStory()

  const goBackUrl = cmsStoryblokSlugToPublicUrl(getParentPath(story.full_slug))

  return (
    <Button<'a'>
      href={goBackUrl}
      slots={{ root: 'a' }}
      startIcon={<IconArrowLeft />}
      variant="text"
    >
      <FormattedMessage id="general.link.label.back" />
    </Button>
  )
}
